import { useState } from "react"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import wsClient from "src/wsClient"
import { selectIsGameFinished } from "src/store/game"

import "./SurrenderButton.css"

const SurrenderButton = ({ disabled = false }) => {
  const { t } = useTranslation()
  // Two steps on purpose. Surrender is immediate and irrevocable — the backend has no undo — so it
  // must not be reachable with one stray click, and it lives away from the round controls.
  const [confirming, setConfirming] = useState(false)
  const isFinished = useSelector(selectIsGameFinished)

  if (isFinished) return null

  const surrender = () => {
    wsClient.send("game", { action: "surrender" })
    setConfirming(false)
  }

  // Looking back at a past round: the button stays where it was, and a half-made surrender waits.
  if (!confirming || disabled) {
    return (
      <button className="surrender-button" disabled={disabled} onClick={() => setConfirming(true)}>
        {t("game.surrender.button")}
      </button>
    )
  }

  return (
    <div className="surrender-confirm">
      <span className="p-mini">{t("game.surrender.confirm")}</span>
      <button className="surrender-yes" onClick={surrender}>
        {t("game.surrender.button")}
      </button>
      <button className="surrender-no" onClick={() => setConfirming(false)}>
        {t("game.surrender.keepPlaying")}
      </button>
    </div>
  )
}

export default SurrenderButton
